import script from "./FormRadio.vue?vue&type=script&setup=true&lang=js"
export * from "./FormRadio.vue?vue&type=script&setup=true&lang=js"

import "./FormRadio.vue?vue&type=style&index=0&id=70084c52&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-70084c52"]])

export default __exports__